/**
 * AgentSupportPoints
 *
 * What agent support does, rendered from the served plan copy (BR-113, PC-3) so the agent screens
 * never carry their own wording of the agent bullets.
 */

import { usePlanCopyQuery } from '../../hooks/useBilling';
import { Skeleton } from '../ui/skeleton';
import { LoadErrorAlert } from './LoadErrorAlert';

export function AgentSupportPoints({ testId }: { testId: string }) {
  const { data, isLoading, isError, refetch, isFetching } = usePlanCopyQuery();

  if (isLoading) {
    return (
      <div className="flex flex-col gap-2" data-testid={`${testId}-loading`}>
        <Skeleton className="h-4 w-3/4" />
        <Skeleton className="h-4 w-2/3" />
      </div>
    );
  }
  if (isError || !data) {
    return (
      <LoadErrorAlert
        message="We couldn't load what agent support does. Try again."
        onRetry={() => void refetch()}
        retrying={isFetching}
        testId={`${testId}-error`}
        retryTestId={`${testId}-retry`}
      />
    );
  }
  return (
    <ul className="m-0 flex list-disc flex-col gap-1 pl-5 text-sm text-muted-foreground" data-testid={testId}>
      {data.agent.points.map((point) => (
        <li key={point.name}>{point.name}</li>
      ))}
    </ul>
  );
}
